import React from 'react';
import { Button } from './Button';
import '../App.css';
import './HeroSection.css';

function HeroSectionAutomotive() {
    return (
        <div className='hero-container-automotive'>
            <video src='/videos/video-2.mp4' autoPlay loop muted />
            <div className='hero-container-inner'>
            <h1>Automotive Accessories</h1>
            <p>OFFICIAL DISTRIBUTOR IN SOUTHERN AFRICA</p>
            <div className='hero-btns'>
                <Button 
                    className='btns'
                    buttonStyle='btn--outline'
                    buttonSize='btn--large'
                >
                ENQUIRE
                </Button>
            </div>
            </div>
            
        </div>
    )
}

export default HeroSectionAutomotive;
